import React, { Component } from 'react'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'

import {
  Grid,
  // Container,
  Paper,
  Button
} from '@material-ui/core/'

import Alert from '../../../Alert/Alert'
import GradeTable from './Table/GradeTable'
import ForceRankTable from './Table/ForceRankTable'
import GradeChart from './Chart/GradeChart'
import ForceRankChart from './Chart/ForceRankChart'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { CircularProgress } from '@material-ui/core'
// import * as actions from '../../../../store/actions'
// import { connect } from 'react-redux'
import _ from 'lodash'

class ForceRankPageContent extends Component {
  state = {
    gradeData: [],
    data: [],
    validForceRank: false,
    saveGrade: [],
    calGrade: [],
    adjust_grade: [],
    valid: false,
    save: false,
    adjustData: [],
    openDialog: false,
    checkGrade: false,
    newData: [],
    adjustRaw: [],
    dataRaw: [],
    adjust_option: [],
    show: true,
    checkValid: [],
    popCal: [],
    showStatus: false
  }

  static getDerivedStateFromProps (props, state) {
    if (props?.unData) {
      let Data = props.unData
      let adjust = []
      let showStatus = false
      Object.entries(Data).reduce((updatedData, data) => {
        let [, dataAttrs] = data
        let status = ''
        if (dataAttrs?.result_structure) {
          dataAttrs.result_structure.map(item => {
            let statusCode = item?.result_item[0]?.stage.status_code
            if (!['CLS', 'VFR', 'DFR', 'HFR'].includes(statusCode)) {
              status = 'in Evaluation Process'
              showStatus = true
            } else if (statusCode === 'VFR') {
              status = 'to Horizontal Director'
              showStatus = true
            } else if (statusCode === 'DFR') {
              status = 'to Horizontal Board'
              showStatus = true
            } else if (statusCode === 'HFR') {
              status = 'End Horizontal Board'
              showStatus = true
            }
            return item
          })
        }
        adjust.push({
          no: adjust.length + 1,
          emp_code: dataAttrs.emp_detail.emp.emp_code,
          emp_name: dataAttrs.emp_detail.emp.full_name,
          org_name: dataAttrs.emp_detail.org?.org_name,
          level_name: dataAttrs.emp_detail?.level?.level_name,
          position_name: dataAttrs.emp_detail.position?.position_name,
          status: status
        })
        return data
      }, {})

      return {
        adjustRaw: adjust,
        show: false,
        showStatus: showStatus
      }
    }
    if (props.data !== state.dataRaw) {
      let Data = props.data
      let adjust = []
      let adjust_option = []
      let amountGrade = []
      let gradeTotal = {}
      let checkCal = false
      Object.entries(Data).reduce((updatedData, data) => {
        let [dataKey, dataAttrs] = data
        gradeTotal = {
          ...gradeTotal,
          [dataKey]: dataAttrs.length
        }
        props.adjustData.map(grade => {
          if (dataKey === grade.value_list_name) {
            adjust_option.push({
              key: grade.value_list_id,
              value: grade.value_list_id,
              label: grade.value_list_name
            })
          }
          return grade
        })

        Object.entries(gradeTotal).map(item => {
          let [keyGrade, attrGrade] = item
          if (dataKey === keyGrade) {
            amountGrade.push(attrGrade)
          }
          return item
        })
        checkCal = _.isEqual(state.saveGrade, amountGrade)

        // chart.push({ adjust_grade: dataKey, total: dataAttrs.length })
        dataAttrs.map(attrs => {
          props.adjustData.map(grade => {
            if (grade.value_list_name === dataKey) {
              adjust.push({
                ...attrs,
                grade: dataKey,
                adjust_grade_label: grade.value_list_name,
                adjust_grade: grade.value_list_id,
                no: adjust.length + 1,
                emp_code: attrs.emp_detail.emp.emp_code,
                emp_name: attrs.emp_detail.emp.full_name,
                org_name: attrs.emp_detail.org.org_name,
                level_name: attrs.emp_detail.level.level_name,
                level_group: attrs.emp_detail.level?.level_group?.level_group_name,
                position_name: attrs.emp_detail.position?.position_name
              })
            }
            return grade
          })
          return attrs
        })
        return data
      }, {})

      return {
        dataRaw: props.data,
        adjustRaw: adjust,
        adjust_option: adjust_option,
        checkGrade: checkCal
      }
    }
    if (props.popCal !== state.popCal) {
      return {
        popCal: props.popCal,
        adjustRaw: props.popCal
      }
    }
    return null
  }

  inputAdjustChange = data => {
    this.setState({
      adjustRaw: data
    })
  }

  inputGradeChange = (data, amount) => {
    let valid = false
    let sum = 0
    let grade = []
    let saveGrade = []
    let validCheck = []

    data.map(item => {
      sum = sum + item.amount
      grade.push(item.amount)
      return item
    })

    data.map(item => {
      if (item.amount > +item.checkAmount + 1 || item.amount < +item.checkAmount - 1) {
        return validCheck.push({
          valid: true,
          value_list_name: item.value_list_name
        })
      } else {
        return validCheck.push({
          valid: false,
          value_list_name: item.value_list_name
        })
      }
    })

    if (sum === amount) {
      valid = true
      saveGrade = {
        grade: grade,
        amount_grade: amount
      }
    }
    this.setState({
      gradeData: data,
      validForceRank: valid,
      saveGrade: saveGrade,
      checkValid: validCheck
    })
  }

  adjustGradeChange = data => {
    this.setState({
      adjust_grade: data
    })
  }

  saveGrade = adjustRaw => {
    let vrf = []
    let data_adjust = []

    this.state.gradeData.map(item => {
      vrf.push({
        company_id: this.props.filterControls.company_id.value.value,
        fr_group_id: this.props.filterControls.fr_group_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        grade_id: item.value_list_id,
        budget_percent: item.budget_percent,
        budget_emp: item.amount
      })
      return {
        vrf
      }
    })

    this.state.adjustRaw.map(item => {
      data_adjust.push({
        company_id: item.company_id,
        result_id: item.result_id,
        grade_id: item.adjust_grade,
        mg_id: item.adjust_grade,
        bg_id: item.adjust_grade,
        sa: parseInt(item.salary),
        rp: parseFloat(item['raise_%']),
        ra: item.raise_amount,
        nsa: item.new_salary,
        bm: parseFloat(item.bonus_month),
        ba: item.bonus
      })
      return item
    })

    let saveData = { vrf: vrf, fr: data_adjust }
    this.props.createForceRank(saveData)
  }

  handleCancel = () => {
    window.location.reload(false)
  }

  handleClickOpen = () => {
    let dataCheck = []
    let matches = this.state.checkValid.map(result => {
      if (result.valid === true) {
        dataCheck.push(result.value_list_name)
        return true
      } else {
        return false
      }
    })

    if (this.state.validForceRank && !matches.includes(true)) {
      let param = {
        ...this.state.saveGrade,
        company_id: this.props.filterControls.company_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        fr_group_id: this.props.filterControls.fr_group_id.value.value
      }

      this.props.fetchForceRankList(param)
      this.setState({
        save: true
      })
    } else if (!this.state.validForceRank) {
      return this.props.fireAlert({
        message: this.props.translate('alertGrade'),
        options: {
          variant: 'error'
        }
      })
    } else if (matches.includes(true)) {
      dataCheck.map(result => {
        return this.props.fireAlert({
          message: 'Grade ' + result + ' +/- ไม่เกิน 1',
          options: {
            variant: 'error'
          }
        })
      })
    }
  }

  handleClose = () => {
    this.setState({ openDialog: false })
  }

  checkGrade = checkGrade => {
    this.setState({ checkGrade: checkGrade })
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.data !== this.props.data) {
  //     this.props.fetchForceRankCalculate({ adjust: this.state.adjustRaw })
  //   }
  // }

  render () {
    return (
      <Aux>
        <Alert />
        <Paper
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: '#DDDDDD',
            padding: '10px',
            marginBottom: '15px'
          }}>
          <Grid container direction={'row'} spacing={1} justify={'flex-end'}>
            <Grid item>
              <Button
                variant='contained'
                disabled={this.props.unData ? true : false}
                style={{
                  minWidth: 100,
                  backgroundColor: '#FFCC00'
                }}
                onClick={this.handleClickOpen}>
                {this.props.translate('AdjustGrade')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                startIcon={this.props.loading ? <CircularProgress size={14} /> : null}
                variant='contained'
                color={'primary'}
                disabled={
                  this.props.loading || (this.state.save && this.state.checkGrade === true)
                    ? false
                    : true
                }
                onClick={() => this.saveGrade()}>
                {this.props.translate('save')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color={'secondary'}
                onClick={() => {
                  this.handleCancel()
                }}>
                {this.props.translate('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={3}>
            <GradeTable
              unData={this.props.unData}
              gradeData={this.state.gradeData}
              notData={this.props.adjustData}
              grade={(data, amount) => this.inputGradeChange(data, amount)}
              adjustData={this.props.adjustData}
              filterControls={this.props.filterControls}
              fetchForceRankList={param => {
                this.props.fetchForceRankList(param)
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} lg>
            <GradeChart gradeData={this.state.gradeData} />
          </Grid>
          <Grid item xs={12} md={12} lg>
            <ForceRankChart
              gradeData={this.state.gradeData}
              adjust_grade={this.state.adjust_grade}
              adjustData={this.props.adjustData}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <ForceRankTable
              data={this.props.data}
              popCal={this.props.popCal}
              show={this.state.show}
              adjustRaw={this.state.adjustRaw}
              loading={this.props.loading}
              adjust_option={this.state.adjust_option}
              filterControls={this.props.filterControls}
              adjust_grade={data => this.adjustGradeChange(data)}
              valid={valid => this.setState({ valid: valid })}
              dataAdjust={data => this.inputAdjustChange(data)}
              adjustData={this.props.adjustData}
              gradeData={this.state.gradeData}
              calGrade={this.state.calGrade}
              fetchForceRankList={param => {
                this.props.fetchForceRankList(param)
              }}
              fetchForceRankCalculate={param => {
                this.props.fetchForceRankCalculate(param)
              }}
              checkGrade={this.checkGrade}
              showStatus={this.state.showStatus}
            />
          </Grid>
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(ForceRankPageContent)
